const cashiersStatus = {
    active: 'Active',
    inactive: 'Inactive',
}

export default cashiersStatus